import React, { useState, useEffect, Component } from "react";
import {
  Row,
  Col,
  Modal,
  Button,
  Image,
  Form,
  InputGroup,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faTrashAlt,
  faExclamationTriangle,
  faTimes,
} from "@fortawesome/pro-light-svg-icons";
import {
  ssnMasking,
  usDateFormat,
  getParamsFromQueryString,
  MANAGE_PAYROLL_ROUTES,
  EMPLOYEE_RECORDS_TO_FETCH,
  YYYYMMDDdateFormat,
} from "../../../../utils";
import { get, toLower, camelCase } from "lodash";
import {
  FormControlSearch,
  FormLeaveGuard,
  SliderPanel,
  CsplTable as Table,
  Link,
} from "../../../../components";
import {
  getAllRecords,
  getTempEmployeeDetailsById,
} from "../../../../services";
import AddToolTip from "../../../../components/AddToolTip";
import { useHistory } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroller";
import { LoaderWrapper } from "../../../../components";
import { useDeepEffect } from "../../../../abstracts";
import authService from "../../../../components/api-authorization/AuthorizeService";
import permissions from "../../../../mocks/menuPermissions.json";
import PayrollCensusDetails from "../../ErrorFoundInRecordsContainer/PayrollCensusDetails";
// const EMPLOYEE_RECORDS_TO_FETCH = 5;
const AllRecordReports = (props) => {
  const {
    fileId,
    toggleUseEffect,
    countTrigger,
    setcountTrigger,
    pendingSubmission,
    homeSetIsLoading,
    isRecordDeleted,
    setIsRecordDeleted,
    allRecords,
    menu,
    subMenu,
    setIsSubmit,
    revalidateIds,
    revalidateFile,
    countries,
    states,
    frequencyList,
  } = props;
  const [roleName, setRoleName] = useState("VOU");
  useEffect(() => {
    getRole();
  }, []);
  const getRole = async () => {
    setRoleName(await authService.getRole());
  };
  const history = useHistory();
  const [recordToDelete, setRecordToDelete] = useState({});
  const [isSliderOpen, setSliderOpen] = useState(false);
  const [filteredValues, setFilteredValues] = useState([]);
  const [selectedTabIndex, setTabIndex] = useState("warning");
  const [toggle, setToggle] = useState(true);
  const [stopInfiniteScroll, setStopInfiniteScroll] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [append, setAppend] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [empId, setEmpId] = useState(null);
  const [request, setRequest] = useState({
    fileId: fileId,
    from: 0,
    offset: EMPLOYEE_RECORDS_TO_FETCH,
    searchInput: "",
  });
  useDeepEffect(() => {
    homeSetIsLoading(true);
    getAllRecords(request)
      .then((response) => {
        if (response.errorReportDetails?.length < EMPLOYEE_RECORDS_TO_FETCH)
          setStopInfiniteScroll(true);

        //setFilteredValues(response.errorReportDetails);
        if (append && searchTerm == "")
          setFilteredValues([
            ...filteredValues,
            ...response.errorReportDetails,
          ]);
        else {
          setFilteredValues(response.errorReportDetails);
          setStopInfiniteScroll(false);
        }
        homeSetIsLoading(false);
        setcountTrigger(!countTrigger);
      })

      .catch((error) => {
        //Handle Errors
        //setIsLoading(false);
      });
  }, [request, toggle, isSliderOpen]);
  useDeepEffect(() => {
    if (searchTerm == "") setRequest({ ...request, from: 0, searchInput: "" });
    else {
      setRequest({
        ...request,
        from:
          filteredValues?.length - EMPLOYEE_RECORDS_TO_FETCH < 0
            ? 0
            : filteredValues?.length - EMPLOYEE_RECORDS_TO_FETCH,
        searchInput: searchTerm,
      });
    }
  }, [searchTerm]);
  const removeOne = (item) => {
    setRecordToDelete(item);
  };
  const handleSearchChange = (e) => {
    const val = e.target.value;
    val.includes("/")
      ? setSearchTerm(YYYYMMDDdateFormat(val))
      : setSearchTerm(val);
    if (!stopInfiniteScroll) {
      setAppend(false);
      // setFilteredValues([]);
      //setRequest({ ...request, from: 0, searchInput: "" });
    }
    // setFilteredValues(
    //   filteredValues.filter((item) => {
    //     return (
    //       toLower(item.ssn).replace(/-/g, "").indexOf(toLower(val)) !== -1 ||
    //       toLower(item.employeeName).indexOf(toLower(val)) !== -1
    //     );
    //   })
    // );
  };

  // const onDeleteConfirmClick = () => {
  //   const id = get(recordToDelete, "id");
  //   deleteTempEmployeeById(id).then((response) => {
  //     setFilteredValues([]);
  //     setIsRecordDeleted(!isRecordDeleted);
  //     setRequest((request) => {
  //       return { ...request, from: 0 };
  //     });
  //     toggleUseEffect();
  //     setToggle(!toggle);
  //   });
  //   var idLength = allRecords;
  //   if (idLength == 1) {
  //     history.push({
  //       pathname: MANAGE_PAYROLL_ROUTES.UPLOADED_FILES_LISTING,
  //     });
  //   } else {
  //     setRecordToDelete({});
  //   }
  // };

  return (
    <div>
      <div className="search-bar-warning-page d-flex-row mt-3 justify-content-space-between">
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            setRequest({
              ...request,
              from:
                filteredValues?.length - EMPLOYEE_RECORDS_TO_FETCH < 0
                  ? 0
                  : filteredValues?.length - EMPLOYEE_RECORDS_TO_FETCH,
              searchInput: searchTerm,
            });
          }}
        >
          <InputGroup>
            <InputGroup.Prepend>
              <InputGroup.Text className="plan-search-button">
                <Image src="/assets/icons/svg/search.svg" width="14px" />
              </InputGroup.Text>
            </InputGroup.Prepend>
            <FormControlSearch
              type="search"
              placeholder="Search employee name, SSN"
              onChange={handleSearchChange}
              // onKeyPress={(event) => {
              //   if (event.key === "Enter") {
              //     event.preventDefault();
              //   }
              // }}
            />
          </InputGroup>
        </Form>

        {/* <div
          className="link-text-mapper ft-14 cursor-pointer"
          style={{
            marginRight: "5px",
            marginTop: "8px",
          }}
          onClick={() => {
            revalidateIds(revalidateFile);
          }}
        >
          <i class="fa fa-retweet mr-2" aria-hidden="true"></i>Revalidate
        </div> */}
      </div>
      <div
        className="error-types-box-var1 font-weight-500 mt-2 d-flex justify-content-space-between"
        style={{ width: "100%" }}
      >
        <Col md="3" className="grey-text">
          Social Security Number
        </Col>
        <Col md="3" className="grey-text">
          Employee name{" "}
        </Col>
        <Col md="3" className="grey-text">
          Pay date
        </Col>
        <Col md="3" className="grey-text">
          Status
        </Col>
        {/* <Col md="1">Action</Col> */}
      </div>
      <div
        className="cursor-pointer validation-error-report w-100"
        //style={{ overflow: "scroll", height: "60vh" }}
      >
        <InfiniteScroll
          pageStart={0}
          loadMore={() => {
            setAppend(true);
            // alert(1)
            setRequest({
              ...request,
              from: filteredValues?.length,
              searchInput: searchTerm,
            });
          }}
          hasMore={!stopInfiniteScroll}
          initialLoad={false}
          threshold={100}
          useWindow={false}
          loader={
            isLoading ? (
              <div className="loader" key={0}>
                Loading ...
              </div>
            ) : filteredValues?.length < 1 ? (
              <div className="no-found">No Records Found</div>
            ) : null
          }
        >
          {filteredValues.map((data, index) => (
            <>
              <Row
                onClick={() => {
                  setSliderOpen(true);
                  setEmpId(data.id);
                }}
                className="error-types-box-var font-weight-400 mt-3"
                style={{ width: "100%" }}
                key={index}
              >
                <Col md="3" className="align-self-center black-text">
                  {ssnMasking(data.ssn)}
                </Col>
                {data.employeeName?.length >= 30 ? (
                  <Col md="3" className="align-self-center black-text">
                    <OverlayTrigger
                      overlay={<Tooltip>{data.employeeName}</Tooltip>}
                    >
                      <div className="font-weight-500">
                        {data.employeeName.slice(0, 30) + "..."}
                      </div>
                    </OverlayTrigger>
                  </Col>
                ) : (
                  <Col md="3" className="align-self-center black-text">
                    {data.employeeName}
                  </Col>
                )}
                <Col md="3" className="align-self-center black-text">
                  {usDateFormat(data.payDate)}
                </Col>
                <Col md="3" className="align-self-center black-text">
                  {!(data.errorCount || data.warningCount) ? (
                    <span className="grey-text font-weight-500">No Errors</span>
                  ) : (
                    <div style={{ width: "185px" }}>
                      <span className="pending-background mr-1">
                        <span className="pending-text font-weight-500">
                          {data.warningCount}
                        </span>{" "}
                        <span className="font-weight-500">Warnings</span>
                      </span>
                      <span
                        className="error-background"
                        //style={{width:'auto', backgroundColor:'linear-gradient(0deg, rgba(196, 6, 26, 0.1), rgba(196, 6, 26, 0.1)), #FFFFFF',padding:'5px'}}
                      >
                        <span className="error-text font-weight-500">
                          {data.errorCount}
                        </span>{" "}
                        <span className="font-weight-500">Errors</span>
                      </span>
                    </div>
                  )}
                </Col>
              </Row>
            </>
          ))}
        </InfiniteScroll>
        <SliderPanel
          isOpen={isSliderOpen}
          showBackButton={false}
          showCancel={false}
          size="90"
          // onClose={() => setSliderOpen(false)}
        >
          <PayrollCensusDetails
            homeSetIsSubmit={setIsSubmit}
            countTrigger={countTrigger}
            setcountTrigger={setcountTrigger}
            payrollId={fileId}
            // employeeId={data.id}
            setTabIndex={setTabIndex}
            selectedTabIndex={selectedTabIndex}
            setSliderOpen={setSliderOpen}
            employeeId={empId}
            countries={countries}
            states={states}
            frequencyList={frequencyList}
          />
        </SliderPanel>
      </div>

      <div className="no-found">
        {filteredValues?.length < 1 && stopInfiniteScroll
          ? "No records found"
          : ""}
      </div>
    </div>
  );
};

export default AllRecordReports;
